var map = {
	"./assets/arrow-to-bottom.svg": 782,
	"./assets/check-success.svg": 4403,
	"./assets/cross.svg": 3342,
	"./assets/icons8-box_important_exp.svg": 8919,
	"./assets/icons8-check_all.svg": 6542,
	"./assets/icons8-denmark_exp.svg": 6238,
	"./assets/icons8-eye_exp_210C2C.svg": 4198,
	"./assets/icons8-germany_exp.svg": 854,
	"./assets/icons8-great_britain_exp.svg": 3682,
	"./assets/icons8-hide_exp.svg": 5379,
	"./assets/icons8-hide_exp_210C2C.svg": 3477,
	"./assets/icons8-sort_exp_down_210C2C.svg": 5969,
	"./assets/icons8-sort_exp_up_210C2C.svg": 685,
	"./assets/icons8-sweden_exp.svg": 3381,
	"./assets/icons8-trash_can_exp_210C2C.svg": 6637,
	"./assets/icons8-uncheck_all.svg": 1845,
	"./assets/link.svg": 1219,
	"./assets/menu.svg": 3898,
	"./assets/myselfie_confetti.svg": 5987,
	"./assets/myselfie_logo_3.1_py.svg": 9597,
	"./assets/myselfie_logo_3_1.svg": 6194,
	"./assets/myselfie_logo_gray.svg": 5711,
	"./assets/myselfie_logo_green.svg": 4078,
	"./assets/myselfie_logo_white.svg": 3821,
	"./assets/myselie_logo_3.1_wy.svg": 4109,
	"./assets/pen.svg": 2233,
	"./assets/play.svg": 5570,
	"./assets/trashcan.svg": 2133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;